export enum PaidStatus {
    All = null,
    Paid = 1,  
    NotPaid = 2,
}